import {
  Beenhere,
  Edit,
  Flag,
  GetApp,
  ImportExport,
  Publish,
  Restore,
  Stars,
  VpnKey,
  Widgets,
} from '@material-ui/icons'

import SchemaIcon from 'components/Icons/SchemaIcon'
import VariablesIcon from 'components/Icons/VariablesIcon'
import { SidebarOption } from 'contexts/FintalkCloud/types'
import useTranslator from './Translator'

export function useFintalkCloudSidebarItems() {
  const { getTranslation } = useTranslator()

  const listLibrary: Array<SidebarOption> = [
    {
      canBeUsed: ['flow:write'],
      name: getTranslation('menu.libraryChildren.defaultTemplates'),
      icon: <Flag />,
      builderElementToOpen: 'standartTemplates',
      needsAgentName: true,
    },
    {
      canBeUsed: ['flow:write'],
      name: getTranslation('menu.libraryChildren.savedBlocks'),
      icon: <Widgets />,
      builderElementToOpen: 'savedBlocks',
      needsAgentName: true,
    },
    {
      canBeUsed: ['flow:write'],
      name: getTranslation('menu.libraryChildren.saveSelectedBlocks'),
      icon: <Beenhere />,
      builderElementToOpen: 'saveSelectedBlocks',
      needsAgentName: true,
    },
  ]

  const listImporExportBot: Array<SidebarOption> = [
    {
      canBeUsed: ['flow:publish'],
      name: getTranslation('menu.uploadDownloadAgentChildren.upload'),
      icon: <Publish />,
      needsAgentName: true,
      action: 'importAgent',
    },
    {
      canBeUsed: ['flow:publish'],
      name: getTranslation('menu.uploadDownloadAgentChildren.download'),
      icon: <GetApp />,
      needsAgentName: true,
      action: 'exportAgent',
    },
  ]

  const builderSidebarOptions: SidebarOption[] = [
    {
      canBeUsed: ['flow:read', 'flow:write'],
      icon: <SchemaIcon />,
      name: getTranslation('menu.flows'),
      needsAgentName: true,
    },
    {
      canBeUsed: ['flow:write'],
      icon: <VariablesIcon />,
      name: getTranslation('menu.variables'),
      builderElementToOpen: 'entities',
      needsAgentName: true,
    },
    {
      canBeUsed: ['flow:write'],
      icon: <Stars />,
      name: getTranslation('menu.library'),
      children: listLibrary,
      needsAgentName: true,
      needsEdition: true,
    },
    {
      canBeUsed: ['flow:publish'],
      icon: <ImportExport />,
      name: getTranslation('menu.uploadDownloadAgent'),
      children: listImporExportBot,
      needsAgentName: true,
    },
    {
      canBeUsed: ['flow:publish'],
      icon: <Restore />,
      name: getTranslation('menu.publishHistory'),
      builderElementToOpen: 'publishHistory',
      needsAgentName: true,
    },
    {
      canBeUsed: ['access_key:read', 'access_key:write'],
      icon: <VpnKey />,
      name: getTranslation('menu.editAccessKeys'),
      builderElementToOpen: 'keys',
      needsAgentName: true,
    },
    {
      canBeUsed: [],
      icon: <Edit />,
      name: 'Editor de JSON',
      builderElementToOpen: 'jsonFlowEditor',
      needsAgentName: false,
    },
  ]

  return {
    listLibrary,
    listImporExportBot,
    builderSidebarOptions,
  }
}
